import {PROGRESS_STATUSES, UnknownError} from '../../../shared/symbols';

/** Unique identifier for the dashboard genetics upload state. */
export const dashboardGeneticsUploadUniqueStateId = '__DashboardGeneticsUpload__';

/** State model for the dashboard genetics retrieve state. */
export interface DashboardGeneticsUploadStateModel {
  /** Current status of the genetics data upload. */
  uploadProgress: PROGRESS_STATUSES;

  /** Last error that occurs during the genetics data upload. */
  uploadBackendError: UnknownError;
}

/** Default values for state initialization and reset. */
export const dashboardGeneticsUploadStateDefaults: DashboardGeneticsUploadStateModel = {
  uploadProgress: PROGRESS_STATUSES.NOT_INITIALIZED,
  uploadBackendError: null,
};
